import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Paragraph } from '../../typography';
import { withTheme } from '../../theme';
import { Icon } from '../../icon';
import { Pane } from '../../layers';

var FormFieldValidationMessage =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FormFieldValidationMessage, _PureComponent);

  function FormFieldValidationMessage() {
    _classCallCheck(this, FormFieldValidationMessage);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormFieldValidationMessage).apply(this, arguments));
  }

  _createClass(FormFieldValidationMessage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["theme", "children"]);

      return React.createElement(Pane, _extends({
        display: "flex"
      }, props), React.createElement(Icon, {
        icon: "error",
        color: "danger",
        marginTop: 1,
        size: 14,
        marginRight: 8
      }), React.createElement(Paragraph, {
        marginTop: 0,
        size: 300,
        color: "danger",
        role: "alert"
      }, children));
    }
  }]);

  return FormFieldValidationMessage;
}(PureComponent);

FormFieldValidationMessage.displayName = "FormFieldValidationMessage";

_defineProperty(FormFieldValidationMessage, "propTypes", _objectSpread({}, Pane.propTypes, {
  /**
   * The contents of the validation message.
   * This is wrapped in a paragraph, use a string.
   */
  children: PropTypes.node,

  /**
   * Theme provided by ThemeProvider.
   */
  theme: PropTypes.object.isRequired
}));

export default withTheme(FormFieldValidationMessage);